const React = require('react');
const { mainNavigationLinks } = require('./links');
const h = React.createElement;

// Shared by the React app and server-rendered documents. Native details menus
// remain usable on direct page loads without requiring the application bundle.
function SiteHeader({ LinkComponent = 'a', token, logout, isEmployee = false } = {}) {
  const link = (href, label, props = {}) => h(LinkComponent, {
    ...(LinkComponent === 'a' ? { href } : { to: href }), ...props
  }, label);
  const closeMenu = event => event.currentTarget.closest('details')?.removeAttribute('open');
  const links = () => mainNavigationLinks.map(([href, label]) => link(href, label, { key: href, onClick: closeMenu }));
  const signOut = event => { closeMenu(event); logout?.(); };
  return h('header', { className: 'site-header' },
    h('div', { className: 'site-header-inner' },
      link('/', h(React.Fragment, null,
        h('img', { src: '/Logowhite.png', alt: '', width: 64, height: 64 }),
        h('span', { className: 'site-header-brand-name' },
          h('span', null, 'Blake'), ' ', h('span', null, 'Technologies'))
      ), { className: 'site-header-brand', 'aria-label': 'Blake Technologies home' }),
      h('nav', { className: 'site-header-desktop', 'aria-label': 'Main navigation' }, ...links()),
      h('div', { className: 'site-header-account' },
        h('button', { type: 'button', className: 'site-header-notifications', 'aria-label': 'View notifications' },
          h('svg', { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.5, 'aria-hidden': true },
            h('path', { strokeLinecap: 'round', strokeLinejoin: 'round', d: 'M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0' }))),
        token ? h('details', { className: 'site-header-user' },
          h('summary', { role: 'button', 'aria-label': 'Open user menu' }, h('img', { src: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=facearea&w=64&h=64', alt: '', width: 32, height: 32 })),
          h('div', { className: 'site-header-dropdown', role: 'menu' },
            link(isEmployee ? '/business-list' : '/portal', isEmployee ? 'Employee Portal' : 'My Portal', { role: 'menuitem', onClick: closeMenu }),
            h('button', { type: 'button', role: 'menuitem', onClick: signOut }, 'Sign out')))
          : link('/login', 'Login', { className: 'site-header-login' })),
      h('details', { className: 'site-header-mobile' },
        h('summary', { role: 'button', 'aria-label': 'Open main menu', 'aria-controls': 'mobile-menu' },
          h('svg', { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.5, 'aria-hidden': true }, h('path', { d: 'M4 6h16M4 12h16M4 18h16' }))),
        h('nav', { id: 'mobile-menu', 'aria-label': 'Mobile navigation' }, ...links(),
          token ? h('button', { type: 'button', onClick: signOut }, 'Logout') : link('/login', 'Login', { onClick: closeMenu })))));
}
module.exports = { SiteHeader };
